import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Container } from '@material-ui/core'
import { useSelector } from 'react-redux'

import { MuiThemeProvider, CssBaseline } from '@material-ui/core'
import Routes from './app/Routes'
import Header from './app/components/Header'
import CookieConsent from './app/components/CookieConsent'
import GoogleConsentMode from './app/components/GoogleConsentMode'
import Footer from './app/components/Footer'
import Loading from './app/components/Loading'
import UserVerificationAlert from './app/components/UserVerificationAlert'
import { QueryClient, QueryClientProvider } from 'react-query'

import theme from './theme'
import GlobalStyles from './GlobalStyles'
import track from './utils/track'

const queryClient = new QueryClient()

function App() {
  const user = useSelector((state) => state.user)

  React.useEffect(() => {
    track('app_loaded')
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <React.Suspense fallback={<Loading />}>
          <BrowserRouter>
            <Container
              style={{
                width: '99vw', // Ensure it spans the full width of the viewport
                maxWidth: '100%', // Override Material-UI Container's maxWidth property
                minHeight: '100vh', // Make sure it covers the full viewport height
                height: '100%',
                backgroundColor: '#faf7fc',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              {user &&
                !user.verified &&
                process.env.REACT_APP_EMAIL_VERIFICATION === 'true' && (
                  <UserVerificationAlert />
                )}
              <Header />
              <GoogleConsentMode />
              <CookieConsent />
              <Routes />
              <Footer />
            </Container>
          </BrowserRouter>
        </React.Suspense>
      </MuiThemeProvider>
    </QueryClientProvider>
  )
}

export default App
